import { AppBar, Box, IconButton, Toolbar } from "@mui/material";
import { useOktaAuth } from "@okta/okta-react";
import type { JSX } from "react";
import { useState } from "react";
import { useNavigate } from "react-router-dom";

import { LogoutIcon, SprengnetterLogo, SupportIcon, UserCircleIcon } from "@/assets";
import { saveLogoutReturnTo } from "@/helpers/logoutNavigationHelpers";
import { setUserInfo } from "@/pages/applicationMainSlice";
import { useAppDispatch } from "@/store/hooks";

import { SupportMenu, UserMenu } from "./menus";
import LanguageSwitcher from "./menus/LanguageSwitcher";

export const Header = (): JSX.Element => {
  const [userAnchorEl, setUserAnchorEl] = useState<HTMLElement | null>(null);
  const [supportAnchorEl, setSupportAnchorEl] = useState<HTMLElement | null>(null);
  const { oktaAuth, authState } = useOktaAuth();
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const onLogoutClick = (): void => {
    saveLogoutReturnTo();
    oktaAuth.signOut();
    dispatch(setUserInfo(undefined));
  };

  const handleUserMenuClick = (event: React.MouseEvent<HTMLElement>): void => {
    setUserAnchorEl(event.currentTarget);
  };

  const handleSupportMenuClick = (event: React.MouseEvent<HTMLElement>): void => {
    setSupportAnchorEl(event.currentTarget);
  };

  const handleCloseUserMenu = (): void => {
    setUserAnchorEl(null);
  };

  const handleCloseSupportMenu = (): void => {
    setSupportAnchorEl(null);
  };

  const handleLogoClick = (): void => {
    navigate("/");
  };

  return (
    <>
      <UserMenu anchorEl={userAnchorEl} open={Boolean(userAnchorEl)} onClose={handleCloseUserMenu} />
      <SupportMenu anchorEl={supportAnchorEl} open={Boolean(supportAnchorEl)} onClose={handleCloseSupportMenu} />
      <AppBar position="fixed" sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }}>
        <Toolbar
          sx={{
            display: "flex",
            alignItems: "center",
            height: "100%",
            padding: "13px 21px 13px 21px",
            gap: "0px",
            justify: "space-between",
          }}
        >
          <Box onClick={handleLogoClick} sx={{ display: "flex", alignItems: "center", cursor: "pointer" }}>
            <SprengnetterLogo sx={{ width: "147px", height: "50px" }} />
          </Box>
          <Box sx={{ flex: 1 }} />
          {authState?.isAuthenticated && (
            <Box sx={{ display: "flex", justifyContent: "space-around", alignItems: "center" }}>
              <LanguageSwitcher language="de" setLanguage={() => {}} />
              <IconButton onClick={handleSupportMenuClick}>
                <SupportIcon color="primary" />
              </IconButton>
              <IconButton onClick={handleUserMenuClick}>
                <UserCircleIcon color="primary" />
              </IconButton>
              <IconButton onClick={onLogoutClick}>
                <LogoutIcon color="primary" />
              </IconButton>
            </Box>
          )}
        </Toolbar>
      </AppBar>
      <Toolbar />
    </>
  );
};
